import { render, staticRenderFns } from "./PlaylistItemView.vue?vue&type=template&id=123d63bf&"
import script from "./PlaylistItemView.vue?vue&type=script&lang=ts&"
export * from "./PlaylistItemView.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistItemView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports